import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';

export default function Layout({ children }) {
  const { isAuthenticated } = useAuth();

  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',
      background: 'var(--color-bg-secondary)',
    }}>
      {isAuthenticated && <Sidebar />}
      <div style={{
        flex: 1,
        overflow: 'auto',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
      }}>
        {children}
      </div>
    </div>
  );
}
